import { BrowserRouter as Router } from 'react-router-dom'
import { useEffect } from 'react'
import AppRoutes from './routes'
import { ToastProvider } from './context/ToastContext'
import { NetworkProvider } from './context/NetworkContext'
import { LayoutProvider } from './context/LayoutContext'
import { clearSavedEntries } from './web/utils/offlineDB'
import OidcAuthBoundary from './auth/OidcAuthBoundary'
import './App.css'

function App() {
    useEffect(() => {
        clearSavedEntries().catch(console.error);
    }, []);

    return (
        <Router basename={process.env.PUBLIC_URL}>
            <ToastProvider>
                <NetworkProvider>
                    <LayoutProvider>
                        <OidcAuthBoundary>
                            <AppRoutes />
                        </OidcAuthBoundary>
                    </LayoutProvider>
                </NetworkProvider>
            </ToastProvider>
        </Router>
    )
}

export default App
